export default import.meta.ROLLDOWN_FILE_URL_g2oMRQeBX0EhfZ_9hdfvJw